import { AccountInfo, PublicClientApplication } from '@azure/msal-browser'
import { Ref, computed } from 'vue'
import { useAuthStore } from '@/stores/auth-store'
import { getClientRoles } from '@/azure/token-utils'

export type MsalContext = {
  instance: PublicClientApplication
  activeAccount: Ref<AccountInfo | null>
  accounts: Ref<AccountInfo[]>
  isAuthenticated: Ref<boolean>
  idTokenClaims: Ref<Record<string, any> | null>
  clientRoles: Ref<{ [clientCode: string]: string[] }>
  isPWAdmin: Ref<boolean>
  // isLabAdmin: Ref<boolean>
  // isLabUser: Ref<boolean>
}

export function useMsal(): MsalContext {
  const auth = useAuthStore()
  return {
    instance: auth.msalInstance as unknown as PublicClientApplication,
    activeAccount: computed(() => auth.activeAccount),
    accounts: computed(() => auth.accounts),
    isAuthenticated: computed(() => auth.isAuthenticated),
    idTokenClaims: computed(() => auth.idTokenClaims),
    clientRoles: computed(() => getClientRoles(auth.idTokenClaims)),
    isPWAdmin: computed(() => auth.isPWAdmin),
    // isLabAdmin: computed(() => auth.isLabAdmin),
    // isLabUser: computed(() => auth.isLabUser),
  }
}
